export const TOOL_DESCRIPTION =
  'Enter comma separated Site IDs for all sites you want to have create code created for. If the access code already exists, it will be retrieved instead of creating a new one.'
